import { useRef, useState } from "react";


export const FullName = ({onInputChange, onInputBlur, onError, value}) => {

    const fullName  = useRef(null);

    const [inputValue, setInputValue] = useState(value ||  '');

    const handleInputChange = () => {
        const name = fullName.current.name;
        const value = fullName.current.value;
        setInputValue(value);
        onInputChange({name: name, value: value});
    }

    const handleInputBlur = () => {
        const name = fullName.current.name
        const value = fullName.current.value
        onInputBlur({name: name, value: value});
    }

    return (
        <div className="mb-3">
            <label  className="form-label fs-6 fw-bold">ПІБ</label>
            <div className="input-group">
                <input type="text" className="form-control  " name='full-name' value={inputValue} placeholder="Введіть Ваше ім'я" 
                    ref={fullName} 
                    onChange={() => handleInputChange()}
                    onBlur={() => handleInputBlur()}  
                />
            </div>
            {onError['full-name'] && <div className="error-message">{onError['full-name']}</div>} 
        </div>
    )
}
